import { usePrevious } from "@chakra-ui/react"
import {
  FeedbackShowCondition,
  QuestionFeedback
} from "@pathwright/blocks-engine"
import { QuillEditor } from "@pathwright/blocks/src/shared"
import Button from "@pathwright/ui/src/components/button/Button"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { useMemo } from "react"
import { FeedbackContainer } from "./ui"

export const getFeedback = (feedbackList: QuestionFeedback[]) => {
  return feedbackList ? feedbackList[0] : null
}

const htmlToFeedback = (feedbackList: QuestionFeedback[], html: string) => {
  const feedback = getFeedback(feedbackList)
  return feedback
    ? { ...feedback, html }
    : { html, showCondition: "ALWAYS" as FeedbackShowCondition }
}

type FeedbackEditProps = {
  feedbackList: QuestionFeedback[]
  onChange: ({ feedback }: { feedback: QuestionFeedback[] | null }) => void
  instructionText?: string
}

const FeedbackEdit = ({
  feedbackList,
  onChange,
  instructionText = "Add an answer explanation"
}: FeedbackEditProps) => {
  const handleClearFeedback = () => {
    onChange({ feedback: null })
  }

  const handleChange = (html: string) => {
    const feedback = htmlToFeedback(feedbackList, html)
    onChange({ feedback: [feedback] })
  }

  const feedback = getFeedback(feedbackList)
  const feedbackNeedsFocus = usePrevious(useMemo(() => !feedback, [feedback]))

  return (
    <div className="FeedbackEdit">
      {feedback ? (
        <FeedbackContainer>
          <div style={{ width: "100%" }}>
            <QuillEditor
              toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
              html={feedback.html}
              placeholder={"Enter answer explanation"}
              onChange={handleChange}
              autofocus={feedbackNeedsFocus}
              slashCommandKeys={["image"]}
            />
          </div>
          <IconButton
            icon="trash"
            onClick={handleClearFeedback}
            className="EditButton"
          />
        </FeedbackContainer>
      ) : (
        <Button
          styleType="blank"
          className="editModeLink"
          onClick={() => handleChange("")}
        >
          {instructionText}
        </Button>
      )}
    </div>
  )
}

export default FeedbackEdit
